import { Form } from 'antd';
import commaNumber from 'comma-number';

import { VFlex } from '@/components/base';
import Input from '@/components/Inputs/Input';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

/**
 * item_per_day 기반 스크래퍼 전용 필드 컴포넌트
 */
export const ItemPerDayField = (props: {
  required?: boolean;
  maxCount: number;
}) => {
  const { required = false, maxCount } = props;
  return (
    <Form.Item
      label="Daily feedback collection limit"
      layout="vertical"
      tooltip="The number of feedbacks we can collect daily depends on each platform's limits."
      labelCol={{ flex: 1 }}
      rules={[
        {
          validator: (_, value) => {
            const numberValue = Number(value);
            if (numberValue && numberValue < 1) {
              return Promise.reject(
                new Error('Max datapoints to scrap must be greater than 0'),
              );
            }
            if (numberValue && numberValue > maxCount) {
              return Promise.reject(
                new Error(
                  `Max datapoints to scrap must be less than ${commaNumber(
                    maxCount,
                  )}`,
                ),
              );
            }
            return Promise.resolve();
          },
        },
      ]}
      name={SCRAPER_REQ_FIELD_KEY.ITEM_PER_DAY}
      required={required}
    >
      <VFlex g={8}>
        <Input
          sizeType="m"
          placeholder={`Set limit (default: ${commaNumber(maxCount)})`}
        />
      </VFlex>
    </Form.Item>
  );
};
